import {
  Box,
  Button,
  Dialog,
  DialogContent,
  Grid,
  InputAdornment,
  List,
  ListItem,
  MenuItem,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { useCallback } from "react";
import styles from "../../styles/components/manager-notification-filter.module.scss";
import TableFilterIcon from "../../ui/Icons/TableFilterIcon";
import SearchIcon from "../../public/assets/images/icon-gray-search.svg";
import icongrayCross from "../../public/assets/images/icon-sm-cross.svg";
import { Link } from "react-router-dom";
import SelectMonth from "../../ui/Customdropdown/SelectMonth";
import SelectDay from "../../ui/Customdropdown/SelectDay";
import SelectYear from "../../ui/Customdropdown/SelectYear";
import ClearIcon from "../../ui/Icons/ClearIcon";
import ResetIcon from "../../ui/Icons/ResetIcon";
import CustomSelect from "../../ui/Customdropdown/CustomSelect";
import CustomCheckBox from "../../ui/Inputs/CustomCheckBox";
import useFetch from "../../hooks/api/useFetch";
import { useState } from "react";
import { useEffect } from "react";
import { NotificationFilterDates } from "../../data/consts";

const dialogContainer = {
  [`.MuiDialog-container`]: {
    alignItems: "flex-start",

    [`.MuiDialog-paper`]: {
      marginTop: "72px",
      boxShadow: "none",
      borderRadius: "10px !important",
      [`.MuiDialogContent-root`]: {
        padding: "0 11px",
      },
    },
  },
};

const CheckboxLoop = [
  {
    checkLabel: "Original video file added",
    type: 44,
  },
  {
    checkLabel: "Video confirmed",
    type: 0,
  },
  {
    checkLabel: "Social Media post added",
    type: 12,
  },
  {
    checkLabel: "Video denied",
    type: 0,
  },
  {
    checkLabel: "Tipalti access granted",
    type: 11,
  },
  {
    checkLabel: "Support ticket updates",
    type: 8,
  },
];

export default function ManagerNotificationFilter(props) {
  const [searchValue, setSearchValue] = useState("");
  const [currentDateFilter, setCurrentDateFilter] = useState("today");
  // useEffect(()=>{
  //     props.getDataFromChild(searchValue)
  // },[searchValue])
  const [startDate, setStartDate] = useState({
    day: "",
    month: "",
    year: "",
  });
  const [startDate2, setStartDate2] = useState({
    day: "",
    month: "",
    year: "",
  });

  const [openFilterModal, setOpenFilterModal] = useState(false);

  const handleOpenFilterModal = useCallback(() => {
    setOpenFilterModal(true);
  }, []);

  const handleCloseFilterModal = useCallback(() => {
    setOpenFilterModal(false);
  }, []);

  const {
    data: allUsers,
    isLoading,
    isSuccess,
  } = useFetch(["user-notification"], "manager/users");

  const [messageby, setMessageby] = useState("");

  const handleChange1 = (event) => {
    setMessageby(event.target.value);
  };

  const resetMessageBy = () => {
    setMessageby("");
  };

  const [messageto, setMessageto] = useState("");

  const handleChange2 = (event) => {
    setMessageto(event.target.value);
  };

  const resetMessageTo = () => {
    setMessageto("");
  };

  const [noteby, setNoteby] = useState("");

  const handleChange3 = (event) => {
    setNoteby(event.target.value);
  };

  const resetNoteBy = () => {
    setNoteby("");
  };

  const [noteto, setNoteto] = useState("");

  const handleChange4 = (event) => {
    setNoteto(event.target.value);
  };

  const resetNoteTo = () => {
    setNoteto("");
  };

  const handleChildData = (anchorEl) => {
    if (anchorEl.day) {
      setStartDate({ ...startDate, day: anchorEl.day });
    } else if (anchorEl.month) {
      setStartDate({ ...startDate, month: anchorEl.month });
    } else if (anchorEl.year) {
      setStartDate({ ...startDate, year: anchorEl.year });
    }
  };

  const handleChildData2 = (anchorEl) => {
    if (anchorEl.day) {
      setStartDate2({ ...startDate2, day: anchorEl.day });
    } else if (anchorEl.month) {
      setStartDate2({ ...startDate2, month: anchorEl.month });
    } else if (anchorEl.year) {
      setStartDate2({ ...startDate2, year: anchorEl.year });
    }
  };

  const filtereditorList2 = (type, day) => {
    // let date = new Date(2020, 4, 12);
    const date = new Date();
    let dd = date.getDate();
    let mm = date.getMonth();
    let yy = date.getFullYear();
    let getThisWeek = new Date();
    function getMonday(d) {
      var day = d.getDay();
      var diff = d.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
      getThisWeek = new Date(d.setDate(diff));
    }

    if (day == "today") {
      let currentDate = Number(dd) > 9 ? Number(dd) : "0" + Number(dd);
      let currentMonth =
        Number(mm) > 9 ? Number(mm) + 1 : "0" + (Number(mm) + 1);
      let currentYear = Number(yy);
      let published_at_from =
        currentYear + "-" + currentMonth + "-" + currentDate;
      let published_at_to =
        currentYear + "-" + currentMonth + "-" + currentDate;
      props.getDataFromChild({
        startDate: published_at_from,
        endDate: published_at_to,
        type: day,
      });
    } else if (day == "yesterday") {
      let datex = date;
      datex.setDate(dd - 1);
      let currentDate =
        datex.getDate() > 9 ? datex.getDate() : "0" + datex.getDate();
      let currentMonth =
        datex.getMonth() > 9
          ? datex.getMonth() + 1
          : "0" + (datex.getMonth() + 1);
      let currentYear = datex.getFullYear();
      let published_at_from =
        currentYear + "-" + currentMonth + "-" + currentDate;
      let published_at_to =
        currentYear + "-" + currentMonth + "-" + currentDate;
      props.getDataFromChild({
        startDate: published_at_from,
        endDate: published_at_to,
        type: day,
      });
    } else if (day == "this_week") {
      getMonday(date);
      let currentDate = Number(dd) > 9 ? Number(dd) : "0" + Number(dd);
      let currentMonth = mm > 9 ? mm : "0" + (mm + 1);
      let currentYear = Number(yy);
      let currentDate2 =
        getThisWeek.getDate() > 9
          ? getThisWeek.getDate()
          : "0" + getThisWeek.getDate();
      let currentMonth2 =
        getThisWeek.getMonth() > 9
          ? getThisWeek.getMonth() + 1
          : "0" + (getThisWeek.getMonth() + 1);
      let currentYear2 = getThisWeek.getFullYear();
      let published_at_from =
        currentYear2 + "-" + currentMonth2 + "-" + currentDate2;
      let published_at_to =
        currentYear + "-" + currentMonth + "-" + currentDate;
      props.getDataFromChild({
        startDate: published_at_from,
        endDate: published_at_to,
        type: day,
      });
    } else if (day == "last_7_days") {
      let currentDate = Number(dd) > 9 ? Number(dd) : "0" + Number(dd);
      let currentMonth =
        Number(mm) > 9 ? Number(mm) + 1 : "0" + (Number(mm) + 1);
      let currentYear = Number(yy);
      let datex = date;
      datex.setDate(date.getDate() - 7);
      let currentDate2 =
        datex.getDate() > 9 ? datex.getDate() : "0" + datex.getDate();
      let currentMonth2 =
        datex.getMonth() + 1 > 9
          ? datex.getMonth() + 1
          : "0" + (datex.getMonth() + 1);
      let currentYear2 = datex.getFullYear();
      let published_at_from =
        currentYear2 + "-" + currentMonth2 + "-" + currentDate2;
      let published_at_to =
        currentYear + "-" + currentMonth + "-" + currentDate;
      props.getDataFromChild({
        startDate: published_at_from,
        endDate: published_at_to,
        type: day,
      });
    } else if (day == "this_month") {
      let currentDate = Number(dd) > 9 ? Number(dd) : "0" + Number(dd);
      let currentMonth =
        Number(mm) > 9 ? Number(mm) + 1 : "0" + (Number(mm) + 1);
      let currentYear = Number(yy);
      let currentDate2 = "0" + (Number(dd) - Number(dd) + 1);
      let currentMonth2 =
        Number(mm) > 9 ? Number(mm) + 1 : "0" + (Number(mm) + 1);
      let currentYear2 = Number(yy);
      let published_at_from =
        currentYear2 + "-" + currentMonth2 + "-" + currentDate2;
      let published_at_to =
        currentYear + "-" + currentMonth + "-" + currentDate;
      props.getDataFromChild({
        startDate: published_at_from,
        endDate: published_at_to,
        type: day,
      });
    } else if (day == "last_month") {
      let datex = date;
      datex.setDate(date.getDate() - dd);
      let days = datex.getDate() + 1;
      let currentDate = datex.getDate();
      let currentMonth =
        datex.getMonth() + 1 > 9
          ? datex.getMonth() + 1
          : "0" + (datex.getMonth() + 1);
      let currentYear = datex.getFullYear();
      let currentDate2 = "0" + (datex.getDate() - datex.getDate() + 1);
      let currentMonth2 =
        datex.getMonth() + 1 > 9
          ? datex.getMonth() + 1
          : "0" + (datex.getMonth() + 1);
      let currentYear2 = datex.getFullYear();
      let published_at_from =
        currentYear2 + "-" + currentMonth2 + "-" + currentDate2;
      let published_at_to =
        currentYear + "-" + currentMonth + "-" + currentDate;
      props.getDataFromChild({
        startDate: published_at_from,
        endDate: published_at_to,
        type: day,
      });
    } else if (day == "last_6_months") {
      let datex = date;
      datex.setMonth(date.getMonth() - 5);
      let days = datex.getDate();
      let currentDate = dd > 9 ? dd : "0" + dd;
      let currentMonth = mm + 1 > 9 ? mm + 1 : "0" + (mm + 1);
      let currentYear = yy;
      let currentDate2 = "0" + (days - days + 1);
      let currentMonth2 =
        datex.getMonth() + 1 > 9
          ? datex.getMonth() + 1
          : "0" + (datex.getMonth() + 1);
      let currentYear2 = datex.getFullYear();
      let published_at_from =
        currentYear2 + "-" + currentMonth2 + "-" + currentDate2;
      let published_at_to =
        currentYear + "-" + currentMonth + "-" + currentDate;
      props.getDataFromChild({
        startDate: published_at_from,
        endDate: published_at_to,
        type: day,
      });
    } else if (day == "this_year") {
      let currentDate = Number(dd) > 9 ? Number(dd) : "0" + Number(dd);
      let currentMonth =
        Number(mm) > 9 ? Number(mm) + 1 : "0" + (Number(mm) + 1);
      let currentYear = Number(yy);
      let currentDate2 = "0" + (Number(dd) - Number(dd) + 1);
      let currentMonth2 = "0" + (Number(mm) - Number(mm) + 1);
      let currentYear2 = Number(yy);
      let published_at_from =
        currentYear2 + "-" + currentMonth2 + "-" + currentDate2;
      let published_at_to =
        currentYear + "-" + currentMonth + "-" + currentDate;
      props.getDataFromChild({
        startDate: published_at_from,
        endDate: published_at_to,
        type: day,
      });
    } else if (day == "last_year") {
      let datex = date;
      datex.setFullYear(yy - 1);
      let currentDate = 31;
      let currentMonth = datex.getMonth() * 0 + 12;
      let currentYear = datex.getFullYear();
      let currentDate2 = "0" + (datex.getDate() - datex.getDate() + 1);
      let currentMonth2 = "0" + (datex.getMonth() - datex.getMonth() + 1);
      let currentYear2 = datex.getFullYear();
      let published_at_from =
        currentYear2 + "-" + currentMonth2 + "-" + currentDate2;
      let published_at_to =
        currentYear + "-" + currentMonth + "-" + currentDate;
      props.getDataFromChild({
        startDate: published_at_from,
        endDate: published_at_to,
        type: day,
      });
    }
    setCurrentDateFilter(day);
  };
  let tarikh = startDate.year + "-" + startDate.month + "-" + startDate.day;
  let tarikh2 = startDate2.year + "-" + startDate2.month + "-" + startDate2.day;

  const [notificationTypeList, setNotificationTypeList] = useState(
    props?.notificationTypeList?.length ? props?.notificationTypeList : []
  );

  const hadnleNotificationTypeListChange = (newType) => {
    setNotificationTypeList((prev) => {
      if (prev.includes(newType)) {
        return prev.filter((item) => item !== newType);
      } else {
        return [...prev, newType];
      }
    });
  };

  const clearFilter = () => {
    resetMessageBy();
    resetMessageTo();
    resetNoteBy();
    resetNoteTo();
    setNotificationTypeList([]);
    props?.setNotificationTypeList([]);
  };

  useEffect(() => {}, [notificationTypeList]);

  return (
    <>
      <Box className={styles.filterNotification}>
        <Stack
          direction="row"
          alignItems="center"
          flexWrap="wrap"
          justifyContent="space-between"
          className={styles.filterHeading}
        >
          <Button
            className={styles.btnFilter}
            onClick={() => handleOpenFilterModal()}
          >
            <TableFilterIcon />
          </Button>
          <TextField
            id="outlined-size-normal"
            placeholder="Search..."
            InputProps={{
              startAdornment: (
                <InputAdornment
                  position="start"
                  className={searchValue ? styles.startAdmnt : undefined}
                >
                  <img src={SearchIcon} width={11.5} height={11.5} alt="icon" />
                </InputAdornment>
              ),
            }}
            value={searchValue}
            onChange={(e) => {
              setSearchValue(e.target.value);
              props.getDataFromChild(e.target.value);
            }}
            sx={
              searchValue
                ? {
                    border: "1px solid #111AE9 !important",
                    borderRadius: "47px",
                  }
                : undefined
            }
          />
        </Stack>
        <List className={styles.selectMonthList}>
          {NotificationFilterDates.map((item, index) => (
            <ListItem
              key={index}
              className={
                item.value === currentDateFilter ? `${styles.filterToday}` : ""
              }
            >
              <Link
                href="javascript:void(0)"
                onClick={() => filtereditorList2("filter", item.value)}
              >
                {item.name}
              </Link>
              {item.value === currentDateFilter ? (
                <Button>
                  <img src={icongrayCross} width={10} height={10} alt="icon" />
                  view all
                </Button>
              ) : (
                ""
              )}
            </ListItem>
          ))}
        </List>
        <Box className={`${styles.dateRange} commonDateRange`}>
          <Typography variant="overline">Start date</Typography>
          <Stack direction="row" flexWrap="wrap" className={styles.monthStacks}>
            <SelectMonth sendDataToParent={handleChildData} />
            <SelectDay sendDataToParent={handleChildData} />
            <SelectYear sendDataToParent={handleChildData} />
          </Stack>
        </Box>
        <Box className={`${styles.dateRange} commonDateRange`}>
          <Typography variant="overline">End date</Typography>
          <Stack direction="row" flexWrap="wrap" className={styles.monthStacks}>
            <SelectMonth sendDataToParent={handleChildData2} />
            <SelectDay sendDataToParent={handleChildData2} />
            <SelectYear sendDataToParent={handleChildData2} />
          </Stack>
        </Box>
        <Box className={`${styles.dateConfirm} commonDateConfirm`}>
          <Button
            onClick={() =>
              props.getDataFromChild({
                startDate: tarikh,
                endDate: tarikh2,
                type: "custom date",
              })
            }
          >
            <span>Confirm</span> date range
          </Button>
        </Box>
      </Box>
      <Dialog
        open={openFilterModal}
        onClose={handleCloseFilterModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          sx: {
            width: "100%",
            maxWidth: "787px",
            position: "relative",
          },
        }}
        sx={dialogContainer}
      >
        <DialogContent>
          <Stack
            direction={"row"}
            alignItems={"center"}
            flexWrap={"wrap"}
            justifyContent={"space-between"}
            className={styles.filterModalHeader}
          >
            <Typography variant="h4">Filter</Typography>
            <Button startIcon={<ClearIcon />} onClick={clearFilter}>
              Clear
            </Button>
          </Stack>
          <Box className={styles.filterModalBody}>
            <Box className={styles.selectGroupStyled}>
              <Grid
                container
                rowSpacing={1.5}
                columnSpacing={{ xs: 1, sm: 2, lg: 9.5 }}
              >
                <Grid item md={6}>
                  <Box className={styles.formGrpStyled}>
                    <Stack
                      direction={"row"}
                      alignItems={"center"}
                      flexWrap={"wrap"}
                      className={styles.labelHeader}
                    >
                      <Typography variant="caption">Message sent by</Typography>
                      <Button onClick={resetMessageBy}>
                        <ResetIcon />
                      </Button>
                    </Stack>
                    <CustomSelect
                      value={messageby}
                      onChange={handleChange1}
                      displayEmpty
                      renderValue={() => {
                        if (!messageby) {
                          return <span>None</span>;
                        } else {
                          return <span>{messageby}</span>;
                        }
                      }}
                    >
                      <MenuItem value=""></MenuItem>
                      {!isLoading &&
                        isSuccess &&
                        allUsers?.data?.data?.length &&
                        allUsers?.data?.data?.map((user, index) => {
                          const userName = `${user?.name ? user?.name : ""} ${
                            user?.last_name ? user?.last_name : ""
                          }`;
                          return (
                            <MenuItem key={index} value={userName}>
                              {userName}
                            </MenuItem>
                          );
                        })}
                    </CustomSelect>
                  </Box>
                </Grid>
                <Grid item md={6}>
                  <Box className={styles.formGrpStyled}>
                    <Stack
                      direction={"row"}
                      alignItems={"center"}
                      flexWrap={"wrap"}
                      className={styles.labelHeader}
                    >
                      <Typography variant="caption">Note left by</Typography>
                      <Button onClick={resetNoteTo}>
                        <ResetIcon />
                      </Button>
                    </Stack>
                    <CustomSelect
                      value={noteto}
                      onChange={handleChange4}
                      displayEmpty
                      renderValue={() => {
                        if (!noteto) {
                          return <span>None</span>;
                        } else {
                          return <span>{noteto}</span>;
                        }
                      }}
                    >
                      <MenuItem value=""></MenuItem>
                      {!isLoading &&
                        isSuccess &&
                        allUsers?.data?.data?.length &&
                        allUsers?.data?.data?.map((user, index) => {
                          const userName = `${user?.name ? user?.name : ""} ${
                            user?.last_name ? user?.last_name : ""
                          }`;
                          return (
                            <MenuItem key={index} value={userName}>
                              {userName}
                            </MenuItem>
                          );
                        })}
                    </CustomSelect>
                  </Box>
                </Grid>
              </Grid>
            </Box>
            <Box className={styles.checkWrapper}>
              <Box className={styles.checkboxRows}>
                <Grid
                  container
                  rowSpacing={2.55}
                  columnSpacing={{ xs: 1, sm: 2, lg: 9.5 }}
                >
                  {CheckboxLoop.map((item, index) => {
                    return (
                      <Grid key={index} item md={6}>
                        <Stack
                          direction={"row"}
                          alignItems={"center"}
                          flexWrap={"wrap"}
                          className={styles.styledCheck}
                        >
                          <CustomCheckBox
                            checked={
                              notificationTypeList?.includes(item?.type)
                                ? true
                                : false
                            }
                            onChange={() => {
                              hadnleNotificationTypeListChange(item?.type);
                            }}
                          />
                          <Typography variant="caption">
                            {item?.checkLabel}
                          </Typography>
                        </Stack>
                      </Grid>
                    );
                  })}
                </Grid>
              </Box>
            </Box>
          </Box>
          <Stack
            direction={"row"}
            alignItems={"center"}
            justifyContent={"flex-end"}
            className={styles.modalFooter}
          >
            <Button
              className={styles.canelBtn}
              onClick={handleCloseFilterModal}
            >
              Cancel
            </Button>
            <Button
              className={styles.filterBtn}
              onClick={() => {
                props?.setNotificationTypeList(notificationTypeList);
                handleCloseFilterModal();
              }}
            >
              Filter <span>now</span>
            </Button>
          </Stack>
        </DialogContent>
      </Dialog>
    </>
  );
}
